import RoundedButton from 'components/RoundedButton';
import { ASSET_PREFIX } from 'utils/constants';
import { EntryMethod } from 'components/enter/EntryMethod';
import { useContext } from 'react';

import PopupWithDimmedBackground from 'components/PopupWithDimmedBackground';
import { useDrawStore } from 'hooks/stores/useDrawStore';
import { observer } from 'mobx-react-lite';

interface IYourNumbersPopup {
  entryMethod: string;
  onClose: () => void;
}

const YourNumbersPopup = observer(
  ({ entryMethod, onClose }: IYourNumbersPopup) => {
    const { numberSetup } = useDrawStore();

    if (!numberSetup) {
      return null;
    }

    return (
      <PopupWithDimmedBackground
        icon={`${ASSET_PREFIX}/images/enter/your-numbers-popup-icon.svg`}
        onClose={onClose}
        additionalClassName={undefined}
        bannerImage={undefined}
      >
        <div className="grid gap-2em fullWidth">
          <div>
            <p className="xlarge xbold">Your numbers</p>
          </div>

          <div>
            <p className="medium">
              {numberSetup.bonus.length > 0 ? (
                <>
                  Choose <strong>{numberSetup.main.length} main numbers</strong>{' '}
                  between{' '}
                  <strong style={{ whiteSpace: 'nowrap' }}>
                    1 – {numberSetup.main[0]}
                  </strong>{' '}
                  and <strong>1 bonus number</strong> between{' '}
                  <strong style={{ whiteSpace: 'nowrap' }}>
                    1 – {numberSetup.bonus[0]}
                  </strong>
                  .
                </>
              ) : (
                <>
                  Enter <strong>${numberSetup.main.length}</strong> numbers
                  between <strong>1 – {numberSetup.main[0]}</strong>
                </>
              )}
            </p>

            {entryMethod !== EntryMethod.OneOff && (
              <p className="medium">
                These numbers will be entered into the draw every week. You can
                change them at any time from your Account.
              </p>
            )}

            {entryMethod === EntryMethod.FreeSubscription && (
              <p className="medium">Match all 5 to win!</p>
            )}
          </div>

          <RoundedButton
            className="fullWidth"
            onClick={onClose}
          >
            Got it
          </RoundedButton>
        </div>
      </PopupWithDimmedBackground>
    );
  }
);

export default YourNumbersPopup;
